/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_EyebrowInputs */

const en_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const de_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const zh_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系`)
};

const ar_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل`)
};

const fr_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const vi_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ`)
};

const sw_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana`)
};

const th_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อ`)
};

const bs_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ja_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const ko_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의`)
};

const pt_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const it_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatto`)
};

const sv_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const nl_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const da_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const nb_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fi_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot`)
};

const pl_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакт`)
};

const tr_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const hi_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क`)
};

const id_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const ms_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi`)
};

const cs_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const el_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνία`)
};

const he_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר`)
};

const af_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const hu_contact_eyebrow = /** @type {(inputs: Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolat`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Contact_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_eyebrow = /** @type {((inputs?: Contact_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_eyebrow(inputs)
	if (locale === "de") return de_contact_eyebrow(inputs)
	if (locale === "zh") return zh_contact_eyebrow(inputs)
	if (locale === "ar") return ar_contact_eyebrow(inputs)
	if (locale === "fr") return fr_contact_eyebrow(inputs)
	if (locale === "vi") return vi_contact_eyebrow(inputs)
	if (locale === "sw") return sw_contact_eyebrow(inputs)
	if (locale === "th") return th_contact_eyebrow(inputs)
	if (locale === "bs") return bs_contact_eyebrow(inputs)
	if (locale === "ja") return ja_contact_eyebrow(inputs)
	if (locale === "ko") return ko_contact_eyebrow(inputs)
	if (locale === "pt") return pt_contact_eyebrow(inputs)
	if (locale === "it") return it_contact_eyebrow(inputs)
	if (locale === "sv") return sv_contact_eyebrow(inputs)
	if (locale === "nl") return nl_contact_eyebrow(inputs)
	if (locale === "da") return da_contact_eyebrow(inputs)
	if (locale === "nb") return nb_contact_eyebrow(inputs)
	if (locale === "fi") return fi_contact_eyebrow(inputs)
	if (locale === "pl") return pl_contact_eyebrow(inputs)
	if (locale === "ru") return ru_contact_eyebrow(inputs)
	if (locale === "tr") return tr_contact_eyebrow(inputs)
	if (locale === "hi") return hi_contact_eyebrow(inputs)
	if (locale === "id") return id_contact_eyebrow(inputs)
	if (locale === "ms") return ms_contact_eyebrow(inputs)
	if (locale === "cs") return cs_contact_eyebrow(inputs)
	if (locale === "el") return el_contact_eyebrow(inputs)
	if (locale === "he") return he_contact_eyebrow(inputs)
	if (locale === "af") return af_contact_eyebrow(inputs)
	if (locale === "hu") return hu_contact_eyebrow(inputs)
	return en_contact_eyebrow(inputs)
});